<template>
	<div class="defaultImg">
    <div class="fx-header">
			<p>默认图管理</p>
		</div>
		<div class="defaultImg-container">
			<div class="img-div">
				<Upload :shopOrProduct='1' @delProductId='delProductId' :imgSrc='productImg' :productId='productId' @relaod='relaod'></Upload>
				<div class='img-span'>
					<p style="font-size:16px;margin-bottom:10px">当前默认图标</p>
					<p>图标要求：80*80,格式JPG/JPEG/PNG,大小在1M以内</p>
				</div>
			</div>
			<div class="img-list">
				<p style="text-align:left;font-size:16px;padding-left:20px;line-height:40px">商品历史图标（最多可存储十张历史图片）</p>
				<div class="img-list-div" v-for='(item,index) in productImgList' :key='index' @mouseover="imgMouseOver(item)" @mouseout="imgMouseOut(item)">
					<w-image class="img" :src="item.url" alt=""></w-image>
					<div class="img-btn" v-show='item.historyflag === "2"'>
						<el-button type="primary" class="btn" @click="downLoadImg(item.url)"><i class="el-icon-download"></i></el-button>
						<el-button type="danger" class="btn" @click="changeImg(item.id,1)"><i class="el-icon-refresh"></i></el-button>
					</div>
				</div>
			</div>
			<!-- <div class="fx-title title">
				<p>店铺/企业默认图标</p>
			</div>
			<div class="img-div">
				<Upload :shopOrProduct='0' @delShopId='delShopId' :imgSrc='shopImg' :shopId='shopId' @relaod='relaod'></Upload>
				<div class='img-span'>
					<p style="font-size:16px;margin-bottom:10px">当前默认图标</p>
					<p>图标要求：80*80,格式JPG/JPEG/PNG,大小在1M以内</p>
				</div>
			</div>
			<div class="img-list">
				<p style="text-align:left;font-size:16px;padding-left:20px;line-height:40px">店铺/企业历史图标（最多可存储十张历史图片）</p>
				<div class="img-list-div" v-for='(item,index) in shopImgList' :key='index' @mouseover="imgMouseOver(item)" @mouseout="imgMouseOut(item)">
					<img class="img" :src="item.url" alt="" />
					<div class="img-btn"  v-show="item.historyflag ==='2'">
						<el-button type="primary" class="btn" @click="downLoadImg(item.url)"><i class="el-icon-download"></i></el-button>
						<el-button type="danger" class="btn" @click="changeImg(item.id,0)"><i class="el-icon-refresh"></i></el-button>
					</div>
				</div>

			</div> -->
		</div>

	</div>
</template>

<script>
import Upload from '@/components/defaulImg/Upload.vue'
export default {
	name: 'defaultImg',
	components: {
		Upload
	},
	data () {
		return {
			shopImg: '',
			shopId: '',
			productId: '',
			productImg: '',
			productImgList: [],
			shopImgList: []
		}
	},
	created () {
		this.getInfo()
	},
	methods: {
		delShopId () {
			this.shopId = ''
		},
		delProductId () {
			this.productId = ''
		},
		downLoadImg (data) {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.urlQNVShop}/systemcenter/defaultimg/download`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			req.send(data)
		},
		download (blobUrl) {
			const img = document.createElement('a')
			img.style.display = 'none'
			img.download = 'picture.jpg'
			img.href = blobUrl
			img.click()
			img.click()
		},
		imgMouseOver (item) {
			item.historyflag = '2'
		},
		imgMouseOut (item) {
			item.historyflag = '1'
		},
		relaod (data) {
			if (data === true) {
				this.getInfo()
			}
		},
		changeImg (id, type) {
			let params = {
				id: id,
				imgType: type
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/defaultimg/update`,
				data: params
			}).then(res => {
				if (res.result) {
					this.getInfo()
					this.$message.success('替换成功！')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getInfo () {
			this.shopImg = ''
			this.productImg = ''
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/defaultimg/find`
			}).then(res => {
				if (res.result) {
					if (res.data.shopBaseDefaultImg) {
						this.shopImg = res.data.shopBaseDefaultImg.url
						this.shopId = res.data.shopBaseDefaultImg.id
					}
					if (res.data.productBaseDefaultImg) {
						this.productId = res.data.productBaseDefaultImg.id
						this.productImg = res.data.productBaseDefaultImg.url
					}

					this.productImgList = res.data.productHistoryFlag
					if (this.productImgList.length > 0) {
						for (let i = 0; i < this.productImgList.length; i++) {
							this.productImgList[i].showBtn = '1'
						}
					}

					this.shopImgList = res.data.shopHistoryFlag
					if (this.shopImgList.length > 0) {
						for (let i = 0; i < this.shopImgList.length; i++) {
							this.shopImgList[i].showBtn = '1'
						}
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
@import '~$assets/stylus/varsty.styl'
.defaultImg {
	display:flex;
	flex-direction: column;
	height :100%;
	overflow:auto
	.defaultImg-header {
		height:50px;
		line-height:50px;
		text-align:left
		font-size: 16px;
		.back-btn {
			display:inline-block
			height:20px
			width:20px
			background-image:url('~images/icon/back-btn-icon.png')
			background-repeat:no-repeat
			background-position: center
			background-size: cover
			position: relative;
			top: 4px;
			margin: 0 10px;
		}
	}
	.defaultImg-container {
		flex:1;
		padding 10px
		.img-div{
			height 130px
			padding-top :30px;
			width :100%;
			margin-top:20px;
			// border-top :1px solid #edeffc
			.img-span{
				color:#333333
				position :relative;
				top: -95px;
				left: 180px;
				width :400px;
				text-align: left;
			}
		}
		.img-list{
			height :140px
			border:1px solid #edeffc
			margin-bottom :20px
			.img-list-div{
				width :80px;
				height :80px;
				float left;
				margin :10px;
				.img{
					width :100%;
					height :100%
				}
				.img-btn{
					position relative;
					bottom:80px;
					width:80px;
					height :80px;
					background-color :rgba(0, 0, 0, 0.7);
					.btn{
						margin-top :25px;
						width :30px;
						height :30px;
						padding 0
					}
				}
			}
		}
	}
}
</style>
<style lang="stylus">
.el-dialog__header{
	text-align :left
}
.sort-class-dialog {
	height:75%
	display:flex;
	flex-direction: column
	overflow:auto
	.el-dialog__body {
		flex:1
		overflow:auto
		padding: 10px 20px 20px 20px;
	}
}
</style>

